import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const GoogleMapButton = ({ destination, onNavigate }) => {
  const handleClick = () => {
    const encodedDestination = encodeURIComponent(destination);
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}`;
    window.open(googleMapsUrl, "_blank"); // Opens in a new tab
    if (onNavigate) onNavigate();
  };

  return (
    <button
      onClick={handleClick}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        flexShrink: 0,
      }}
    >
      <FaMapMarkerAlt size={20} color="Green" />
    </button>
  );
};

export default GoogleMapButton;
